import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SelectedTrade } from 'src/app/job/models/job-detail/overview/job-detail-overview-selected-trade.model';
import { BehaviorSubject, map, of, tap } from 'rxjs';
import { AssignTradeRequest } from 'src/app/job/models/job-post/assign-trade-request.model';
import { Events } from 'src/app/shared/constants/events.constant';
import { environment } from 'src/environments/environment';
import { BaseService } from '../base/base.service';
import { EventService } from '../event.service';
import {
  ReviewCountResult,
  ReviewsResult,
} from 'src/app/tradee/models/tradee-general-profile.model';
import { ServiceProvider } from 'src/app/job/models/ai-job-post/service-provider.model';
import { Job } from 'src/app/job/models/job-post/job.model';

@Injectable({
  providedIn: 'root',
})
export class JobTradeService extends BaseService {
  private readonly urlPrefix = `${environment.maintenance.urlPrefix}/job-trades`;

  constructor(http: HttpClient, private eventService: EventService) {
    super(http);
  }
  private selectedTradeFromSimilarJobs = new BehaviorSubject<any>(null);
  selectedTradeFromSimilarJobs$ = this.selectedTradeFromSimilarJobs.asObservable();



  award(request: AssignTradeRequest) {
    return this.post<any>(`${this.urlPrefix}/award`, request).pipe(
      tap(() => {
        this.eventService.dispatch(Events.JobApprovedEvent);
      })
    );
  }

  public remind(data: {
    id: string;
    isSendEmail: boolean;
    isSendSMS: boolean;
  }) {
    return this.patch<string>(`${this.urlPrefix}/remind`, data).pipe(
      tap(() => {
        this.eventService.dispatch(Events.RemindTredeToCompleteEvent);
      })
    );
  }

  public update(request: AssignTradeRequest) {
    const hasAssignTradee =
      request.selectedTradees?.length > 0 ||
      request.externalTrade?.companyEmail;

    if (!hasAssignTradee) return of({});
    return this.put<any>(`${this.urlPrefix}/update`, request).pipe(
      tap(() => {
        this.eventService.dispatch(Events.JobEditedEvent);
      })
    );
  }

  getSelectedTrade(jobId: string) {
    let endpointUrl = `${this.urlPrefix}/selected-trade?jobId=${jobId}`;
    return this.get<SelectedTrade[]>(endpointUrl);
  }

  reAward(request: AssignTradeRequest) {
    return this.post<any>(`${this.urlPrefix}/re-award`, request).pipe(
      tap(() => {
        this.eventService.dispatch(Events.JobApprovedEvent);
      })
    );
  }

  getReviewsForTradee(tradeeId: string, pageNo: number, pageSize: number) {
    let endpointUrl = `${this.urlPrefix}/reviews?tradeeId=${tradeeId}&pageNo=${pageNo}&pageSize=${pageSize}`;
    return this.get<ReviewsResult>(endpointUrl);
  }

  getReviewsCountForTradee(tradeeId: string) {
    let endpointUrl = `${this.urlPrefix}/reviews-count?tradeeId=${tradeeId}`;
    return this.get<ReviewCountResult>(endpointUrl);
  }

  sendLearningMaterials(data: any) {
    return this.post<string>(`${this.urlPrefix}/learning-materials`, data);
  }

  getAssignServiceProviders(searchText: string) {
    let params = new HttpParams();
    const job = Job.getInstance();
    params = params.append('propertyId', job.property.id);
    params = params.append('SecondaryJobTypeId', job.secondaryJobType.id);
    params = params.append('MaintenanceType', job.maintenanceType);
    params = params.append('SearchText', searchText);
    if (job.id && job.id.length > 0) params = params.append('JobId', job.id);

    const endpointUrl = `${this.urlPrefix}/assign-trades`;

    return this.getNew<ServiceProvider[]>(endpointUrl, params).pipe(
      map((serviceProviders: ServiceProvider[]) => {
        return serviceProviders.map((sp) => ({ ...sp, selected: false }));
      })
    );
  }
  setSelectedTrade(trade: any) {
    this.selectedTradeFromSimilarJobs.next(trade);
  }
}
